export class Imovel {
  id: number;
  propertyCode:  string;
  newerPropertyCode: string;
  name:  string;
  stateRegistration: string;
  explorationType: string;
  currency:  string;
  itrCode:  string;
  caepf:  string;
  companyId: number;
  street: string;
  houseNumber:string;
  neighborhood: string;
  complement: string;
  cep: string;
  countryId: number;
  stateId:  number;
  cityId: number;
  default: boolean;
  active: boolean;
}
